import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { airflowApiRef, AirflowClientApi } from './services/airflowService';

export const airflowPlugin = createPlugin({
  id: 'airflow',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: airflowApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AirflowClientApi(discoveryApi, fetchApi),
    }),
  ],
});

export const AirflowPage = airflowPlugin.provide(
  createRoutableExtension({
    name: 'AirflowPage',
    component: () =>
      import('./components/AirflowPage').then(m => m.AirflowPage),
    mountPoint: rootRouteRef,
  }),
);
